<template>
    <div class="wrap">
        <div class="complaintBox pdfBox">
            <div id="charts_box" class="charts_box chartsPdf">
                <!-- 第1页 -->
                <div class="pdf_page">
                    <p style="text-align: center; font-size: 34px; letter-spacing: 8px; font-weight: bold; color: #fff">投诉信息分析统计</p>
                    <div class="chartBox public_box">
                        <div class="chartTitle">投诉时间分布</div>
                        <div id="complaintChart10704" class="complaintChartStyle" v-loading="chartLoading1" element-loading-spinner="el-icon-loading" element-loading-background="rgba(12, 36, 82, 0.8)"></div>
                    </div>
                    <div class="editBox">
                        <p v-html="chartsDictData.chart1.value"></p>
                    </div>
                    <div class="chartBox public_box" style="margin-top: -4px; height: 370px">
                        <div class="chartTitle">投诉全量公估公司分布</div>
                        <div id="complaintChart20704" class="complaintChartStyle" v-loading="chartLoading2" element-loading-spinner="el-icon-loading" element-loading-background="rgba(12, 36, 82, 0.8)"></div>
                    </div>
                    <div class="editBox">
                        <p v-html="chartsDictData.chart2.value"></p>
                    </div>
                    <div class="tableBox chartBox public_box" style="margin-top: -4px; height: 455px">
                        <div class="chartTitle">投诉全量渠道分布</div>
                        <div id="complaintChart40704" class="complaintChartStyle chartStyle4" v-loading="chartLoading2" element-loading-spinner="el-icon-loading" element-loading-background="rgba(12, 36, 82, 0.8)"></div>
                    </div>
                    <div class="editBox">
                        <p v-html="chartsDictData.chart3.value"></p>
                    </div>
                    <p class="page_footer">1</p>
                </div>
                <!-- 第2页 -->
                <div class="pdf_page">
                    <div class="tablesBox" style="margin-top: -4px; margin-bottom: 20px">
                        <div class="right_tableBox public_box">
                            <div class="chartTitle">投诉原因占比</div>
                            <div id="complaintChart30704" class="complaintChartStyle" v-loading="chartLoading3"></div>

                            <div class="editBox">
                                <p v-html="chartsDictData.chart4.value"></p>
                            </div>
                        </div>
                        <div class="left_tableBox public_box">
                            <div class="chartTitle">公估公司投诉原因</div>
                            <el-table class="chartTable fontTableStyle" :data="tableData4" stripe v-loading="tableLoading4">
                                <el-table-column prop="company" label="公估公司"> </el-table-column>
                                <el-table-column prop="policy" label="保单" width="55px"> </el-table-column>
                                <el-table-column prop="urgeContact" label="催促联系"> </el-table-column>
                                <el-table-column prop="urgePayment" label="催促赔付"> </el-table-column>
                                <el-table-column prop="other" label="其他"> </el-table-column>
                                <el-table-column prop="attitudeProblem" label="态度问题"> </el-table-column>
                                <el-table-column prop="responsibilityDispute" label="责任争议"> </el-table-column>
                                <el-table-column prop="amountDispute" label="金额争议"> </el-table-column>
                                <el-table-column prop="foodLiabilityInsurance" label="食责险"> </el-table-column>
                            </el-table>

                            <div class="editBox">
                                <p v-html="chartsDictData.table1.value"></p>
                            </div>
                        </div>
                    </div>
                    <div class="tablesBox" style="margin-top: -4px; margin-bottom: 20px">
                        <div class="right_tableBox public_box">
                            <div class="chartTitle">投诉角色占比</div>
                            <div id="complaintChart50704" class="complaintChartStyle" v-loading="chartLoading5"></div>

                            <div class="editBox">
                                <p v-html="chartsDictData.chart5.value"></p>
                            </div>
                        </div>
                        <div class="left_tableBox public_box">
                            <div class="chartTitle">公估公司投诉角色</div>
                            <el-table class="chartTable fontTableStyle" :data="tableData4_1" stripe v-loading="tableLoading4_1">
                                <el-table-column prop="company" label="公估公司"> </el-table-column>
                                <el-table-column prop="rider" label="骑手" width="55"> </el-table-column>
                                <el-table-column prop="thirdParty" label="三者" width="55"> </el-table-column>
                                <el-table-column prop="riderFamily" label="骑手家属"> </el-table-column>
                                <el-table-column prop="thirdPartyFamily" label="三者家属"> </el-table-column>
                                <el-table-column prop="riderAgent" label="骑手代理人"> </el-table-column>
                                <el-table-column prop="thirdPartyAgent" label="三者代理人"> </el-table-column>
                                <el-table-column prop="serviceProvider" label="服务商" width="70"> </el-table-column>
                                <el-table-column prop="foodLiabilityInsuranceCustomer" label="食责险客户"> </el-table-column>
                                <el-table-column prop="repairShop" label="修理厂"> </el-table-column>
                                <el-table-column prop="other" label="其他" width="55"> </el-table-column>
                            </el-table>

                            <div class="editBox">
                                <p v-html="chartsDictData.table4.value"></p>
                            </div>
                        </div>
                    </div>
                    <p class="page_footer">2</p>
                </div>
                <!-- 第3页 -->
                <div class="pdf_page">
                    <div class="tableBox public_box" style="margin-top: -4px; margin-top: 200px">
                        <div class="chartTitle">投诉渠道信息统计</div>
                        <el-table class="chartTable" :data="tableData2" stripe v-loading="tableLoading2">
                            <el-table-column prop="company" label="公估公司" width="180"> </el-table-column>
                            <el-table-column prop="nine5550WorkOrder" label="95500工单"> </el-table-column>
                            <el-table-column prop="formalComplaint" label="正式投诉"> </el-table-column>
                            <el-table-column prop="regulatoryConsultation" label="监管咨询"> </el-table-column>
                            <el-table-column prop="regulatoryFormal" label="监管正式"> </el-table-column>
                            <el-table-column prop="externalPublicOpinion" label="外部舆情"> </el-table-column>
                            <el-table-column prop="regulatoryFormal" label="扬言监管"> </el-table-column>
                            <el-table-column prop="consumerProtectionGuide" label="消保引导"> </el-table-column>
                            <el-table-column prop="consumerProtectionFormal" label="消保正式"> </el-table-column>
                            <el-table-column prop="total" label="合计"> </el-table-column>
                        </el-table>
                    </div>
                    <div class="editBox">
                        <p v-html="chartsDictData.table2.value"></p>
                    </div>
                    <div class="tableBox public_box" style="margin-top: -4px">
                        <div class="chartTitle">投诉协助案件</div>
                        <el-table class="chartTable" :data="tableData3" stripe v-loading="tableLoading3">
                            <el-table-column prop="assistancePerson" label="协助人" width="180"> </el-table-column>
                            <el-table-column prop="nine5550WorkOrder" label="95500工单"> </el-table-column>
                            <el-table-column prop="formalComplaint" label="正式投诉"> </el-table-column>
                            <el-table-column prop="regulatoryConsultation" label="监管咨询"> </el-table-column>
                            <el-table-column prop="regulatoryFormal" label="监管正式"> </el-table-column>
                            <el-table-column prop="externalPublicOpinion" label="外部舆情"> </el-table-column>
                            <el-table-column prop="regulatoryFormal" label="扬言监管"> </el-table-column>
                            <el-table-column prop="consumerProtectionGuide" label="消保引导"> </el-table-column>
                            <el-table-column prop="consumerProtectionFormal" label="消保正式"> </el-table-column>
                            <el-table-column prop="total" label="总数"> </el-table-column>
                            <el-table-column prop="totalAmount" label="总金额"> </el-table-column>
                        </el-table>
                    </div>
                    <div class="editBox">
                        <p v-html="chartsDictData.table3.value"></p>
                    </div>
                    <p class="page_footer">3</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import * as echarts from 'echarts';
export default {
    name: 'offerStatistics',
    props: {
        isTest: {
            type: Boolean,
            default: false
        },
        queryData: {
            type: Object,
            default: {}
        },
        chartsDictData: {
            type: Object,
            default: {}
        }
    },
    components: {},
    data() {
        return {
            pageTitle: '',
            chartLoading1: false,
            chartLoading2: false,
            chartLoading3: false,
            chartLoading4: false,
            chartLoading5: false,
            tableLoading1: false,
            tableLoading2: false,
            tableLoading3: false,
            tableLoading4: false,
            tableLoading4_1: false,
            complaintChart10704: null,
            complaintChart20704: null,
            complaintChart30704: null,
            complaintChart40704: null,
            complaintChart50704: null,
            dateValue: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            navForm: {
                startDay: null,
                endDay: null
            },
            tableData1: [],
            tableData2: [],
            tableData3: [],
            tableData4: [],
            tableData4_1: []
        };
    },
    mounted() {
        this.pageTitle = this.$route.meta.title;
        const date = new Date();
        const yesterday = new Date(date);

        // 设置为前一天
        yesterday.setDate(date.getDate() - 1);
        let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 30);
        this.dateValue = [this.dateFormatting(startDate, 'yyyy-MM-dd'), this.dateFormatting(yesterday, 'yyyy-MM-dd')];
        // this.dateValue = ['2025-01-06', '2025-05-06'];
        this.dateChange(this.dateValue);

        this.renderCharts();

        window.addEventListener('resize', () => {
            this.complaintChart10704 && this.complaintChart10704.resize();
            this.complaintChart20704 && this.complaintChart20704.resize();
            this.complaintChart30704 && this.complaintChart30704.resize();
            this.complaintChart40704 && this.complaintChart40704.resize();
        });
    },
    methods: {
        dateChange(val) {
            if (val) {
                this.navForm = {
                    startDay: val[0],
                    endDay: val[1]
                };
            } else {
                this.navForm = {
                    startDay: null,
                    endDay: null
                };
            }
        },
        //点击查询
        searchTable(clearFlag) {
            this.navForm = this.queryData;

            if (clearFlag) {
                this.complaintChart1.dispose();
                this.complaintChart1 = null;
                this.complaintChart2.dispose();
                this.complaintChart2 = null;
                this.complaintChart3.dispose();
                this.complaintChart3 = null;
                this.complaintChart4.dispose();
                this.complaintChart4 = null;
                this.complaintChart5.dispose();
                this.complaintChart5 = null;
            }

            this.getComplaintTime();
            this.getComplaintCompany();
            this.getComplaintChannels();
            this.getComplaintChannelInfo();
            this.getComplaintAssistanceCases();
            this.getCompanyCause();
            this.getComplaintCause();

            this.getComplaintCompanyId();
            this.getComplaintIdCard();
        },
        renderCharts(clearFlag) {
            if (this.isTest) {
                this.testSearch(clearFlag);
            } else {
                this.searchTable(clearFlag);
            }
        },
        testSearch(clearFlag) {
            if (clearFlag) {
                this.complaintChart1.dispose();
                this.complaintChart1 = null;
                this.complaintChart2.dispose();
                this.complaintChart2 = null;
                this.complaintChart3.dispose();
                this.complaintChart3 = null;
                this.complaintChart4.dispose();
                this.complaintChart4 = null;
                this.complaintChart5.dispose();
                this.complaintChart5 = null;
                this.setChart1(chartsData1.data);
                this.setChart2(chartsData2.data);
                this.setChart3(chartsData3.data);
                this.setChart4(tmpTableData1.data);
                this.setChart5(chartsData4.data);
            } else {
                this.setChart1(chartsData1.data);
                this.setChart2(chartsData2.data);
                this.setChart3(chartsData3.data);
                this.setChart4(tmpTableData1.data);
                this.setChart5(chartsData4.data);
            }
            this.tableData1 = tmpTableData1.data;
            this.tableData2 = tmpTableData2.data;
            this.tableData3 = tmpTableData3.data;
            this.tableData4 = tmpTableData4.data;
            this.tableData4_1 = tmpTableData4_1.data;
        },
        getComplaintTime() {
            this.chartLoading1 = true;
            this.instance.post('/complaintInfo/complaintTimeDistribution', this.navForm).then((res) => {
                this.chartLoading1 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart1(data.data);
                }
            });
        },
        getComplaintCompany() {
            this.chartLoading2 = true;
            this.instance.post('/complaintInfo/complaintCompanyDistribution', this.navForm).then((res) => {
                this.chartLoading2 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart2(data.data);
                }
            });
        },
        getComplaintCompanyId() {
            this.tableLoading4_1 = true;
            this.instance.post('/complaintInfo/complaintCompanyIdCardDistribution', this.navForm).then((res) => {
                this.tableLoading4_1 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData4_1 = data.data;
                } else {
                    this.tableData4_1 = [];
                }
            });
        },
        getComplaintIdCard() {
            this.tableLoading5 = true;
            this.instance.post('/complaintInfo/complaintIdCardDistribution', this.navForm).then((res) => {
                this.tableLoading5 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart5(data.data);
                }
            });
        },
        getComplaintChannels() {
            this.tableLoading1 = true;
            this.instance.post('/complaintInfo/complaintChannelsDistribution', this.navForm).then((res) => {
                this.tableLoading1 = false;
                let data = res.data;
                if (data.code == 1) {
                    // this.tableData1 = data.data;
                    this.setChart4(data.data);
                } else {
                    this.tableData1 = [];
                }
            });
        },
        getComplaintChannelInfo() {
            this.tableLoading2 = true;
            this.instance.post('/complaintInfo/complaintChannelInfoDistribution', this.navForm).then((res) => {
                this.tableLoading2 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData2 = data.data;
                } else {
                    this.tableData2 = [];
                }
            });
        },
        getComplaintAssistanceCases() {
            this.tableLoading3 = true;
            this.instance.post('/complaintInfo/complaintAssistanceCases', this.navForm).then((res) => {
                this.tableLoading3 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData3 = data.data;
                } else {
                    this.tableData3 = [];
                }
            });
        },
        getCompanyCause() {
            this.tableLoading4 = true;
            this.instance.post('/complaintInfo/complaintCompanyCauseDistribution', this.navForm).then((res) => {
                this.tableLoading4 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.tableData4 = data.data;
                } else {
                    this.tableData4 = [];
                }
            });
        },
        getComplaintCause() {
            this.chartLoading3 = false;
            this.instance.post('/complaintInfo/complaintCauseDistribution', this.navForm).then((res) => {
                this.chartLoading3 = false;
                let data = res.data;
                if (data.code == 1) {
                    this.setChart3(data.data);
                }
            });
        },
        setChart1(resData) {
            // 计算日期范围天数
            function getDateRangeDays(start, end) {
                const startDate = new Date(start);
                const endDate = new Date(end);
                const diffTime = Math.abs(endDate - startDate);
                return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            }
            let days = 0;
            if (this.navForm.startDay && this.navForm.endDay) {
                days = getDateRangeDays(this.navForm.startDay, this.navForm.endDay);
            }
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                seriesData3 = [],
                legendData = ['投诉全量', '诉求工单', '报案量'];

            if (!resData) {
                return;
            }

            resData.forEach((item) => {
                xAxisData.push(item.time);
                seriesData1.push(item.reportNum || 0);
                seriesData2.push(item.complaintNum || 0);
                seriesData3.push(item.complaintFormNum || 0);
            });

            let chartDom = document.getElementById('complaintChart10704');
            this.complaintChart10704 = echarts.init(chartDom);

            let colorArr = ['#FAC859', '#409EFE', '#91CB74'];
            let option = {
                textStyle: {
                    fontSize: 14 // 全局文字大小
                },
                color: colorArr,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: legendData,
                    textStyle: {
                        color: '#fff', // 图例文字颜色
                        fontSize: 14 // 可选：文字大小
                    },
                    bottom: 0 // 距离底部距离
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '15%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData,
                        axisLabel: {
                            rotate: days > 30 ? 45 : 0, // 关键配置：超过30天则倾斜45度
                            interval: days > days * 10 ? 10 : 0 // 超过30天则自动稀疏显示
                        },
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' // X 轴轴线颜色
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#fff' // X 轴刻度线颜色
                            }
                        },
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#FAC859',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '报案量',
                        type: 'line',
                        label: {
                            show: true, // 显示数值标签
                            position: 'bottom', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        yAxisIndex: 1,
                        data: seriesData1
                    },
                    {
                        name: '投诉全量',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        barMaxWidth: 40,
                        barGap: 0,
                        data: seriesData2
                    },
                    {
                        name: '诉求工单',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        barMaxWidth: 40,
                        data: seriesData3
                    }
                ]
            };
            this.complaintChart10704.setOption(option);
        },
        setChart2(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                legendData = ['诉求工单', '投诉全量'];

            if (!resData) {
                return;
            }

            resData.forEach((item) => {
                xAxisData.push(item.company);
                seriesData1.push(item.complaintNum || 0);
                seriesData2.push(item.complaintFormNum || 0);
            });

            let chartDom = document.getElementById('complaintChart20704');
            this.complaintChart20704 = echarts.init(chartDom);

            let option = {
                textStyle: {
                    fontSize: 14 // 全局文字大小
                },
                color: ['#409EFE', '#FAC859'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: legendData,
                    textStyle: {
                        color: '#fff', // 图例文字颜色
                        fontSize: 14 // 可选：文字大小
                    },
                    bottom: 0 // 距离底部距离
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '15%',
                    top: '10%',
                    containLabel: true // 是否包含坐标轴标签
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData,
                        axisLine: {
                            lineStyle: {
                                color: '#fff' // X 轴轴线颜色
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#fff' // X 轴刻度线颜色
                            }
                        },
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#FAC859',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '诉求工单',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        barMaxWidth: 40, // 最大不超过80像素
                        data: seriesData2
                    },
                    {
                        name: '投诉全量',
                        type: 'line',
                        label: {
                            show: true, // 显示数值标签
                            position: 'bottom', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                        },
                        yAxisIndex: 1,
                        data: seriesData1
                    }
                ]
            };
            this.complaintChart20704.setOption(option);
        },
        setChart3(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                legendData = ['投诉全量', '诉求工单'];

            if (!resData) {
                return;
            }

            seriesData1 = [
                { value: resData['policy'] || 0, name: '保单' },
                { value: resData['urgeContact'] || 0, name: '催促联系' },
                { value: resData['urgePayment'] || 0, name: '催促赔付' },
                { value: resData['foodLiabilityInsurance'] || 0, name: '食责险' },
                { value: resData['amountDispute'] || 0, name: '金额争议' },
                { value: resData['attitudeProblem'] || 0, name: '态度问题' },
                { value: resData['responsibilityDispute'] || 0, name: '责任争议' },
                { value: resData['other'] || 0, name: '其他' }
            ];

            let chartDom = document.getElementById('complaintChart30704');
            this.complaintChart30704 = echarts.init(chartDom);

            let option = {
                textStyle: {
                    fontSize: 14
                },
                grid: {
                    left: '20%',
                    right: '10%',
                    top: '10%',
                    bottom: '10%'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '55%'],
                        data: seriesData1,
                        avoidLabelOverlap: true,
                        label: {
                            color: '#fff',
                            alignTo: 'radial',
                            // formatter: '{b}\n{c} ({d}%)',
                            formatter: '{b}\n{d}%',
                            lineHeight: 15
                        },
                        labelLine: {
                            show: true,
                            length: 30,
                            length2: 100,
                            lineStyle: {
                                // color: '#999',
                                width: 1
                            }
                        }
                    }
                ]
            };
            this.complaintChart30704.setOption(option);
        },
        setChart4(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                seriesData3 = [],
                seriesData4 = [],
                seriesData5 = [],
                legendData = ['诉求工单', '内部投诉', '外部投诉'];

            if (!resData) {
                return;
            }

            resData.forEach((item) => {
                if (item.company != '合计') {
                    // 公估公司
                    xAxisData.push(item.company);
                    // 投诉全量
                    // seriesData1.push(item.complaintNum);
                    // 外部投诉
                    seriesData2.push(item.externalNum);
                    // 内部投诉
                    seriesData3.push(item.internalNum);
                    // 诉求工单
                    seriesData4.push(item.complaintFormNum);
                    // 投诉占比
                    // seriesData5.push(item.ratio);
                }
            });

            let chartDom = document.getElementById('complaintChart40704');

            this.complaintChart40704 = echarts.init(chartDom);

            let colorArr = ['#FAC859', '#409EFE', '#91CB74', '#E97CCB', '#72C0DE'];
            let option = {
                textStyle: {
                    fontSize: 14 // 全局文字大小
                },
                color: colorArr,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: legendData,
                    textStyle: {
                        color: '#fff', // 图例文字颜色
                        fontSize: 14 // 可选：文字大小
                    },
                    bottom: 0 // 距离底部距离
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '10%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisData,
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#fff' // X 轴轴线颜色
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#fff' // X 轴刻度线颜色
                            }
                        },
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#fff',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    },
                    {
                        type: 'value',
                        axisLabel: {
                            color: '#2BE2DF',
                            fontSize: 14
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#fff' // Y 轴网格线颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '诉求工单',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#FAC859' // 标签颜色
                        },
                        barMaxWidth: 40,
                        barGap: 0,
                        data: seriesData4
                    },
                    {
                        name: '内部投诉',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#409EFE' // 标签颜色
                        },
                        barMaxWidth: 40,
                        data: seriesData3
                    },
                    {
                        name: '外部投诉',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#91CB74' // 标签颜色
                        },
                        barMaxWidth: 40,
                        barGap: 0,
                        data: seriesData2
                    },
                    {
                        name: '投诉全量',
                        type: 'bar',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top',
                            rotate: 90,
                            align: 'left',
                            verticalAlign: 'middle', // 标签位置（柱状图顶部）
                            color: '#E97CCB' // 标签颜色
                        },
                        yAxisIndex: 1,
                        barMaxWidth: 40,
                        data: seriesData1
                    },
                    {
                        name: '投诉占比（%）',
                        type: 'line',
                        label: {
                            show: true, // 显示数值标签
                            position: 'top', // 标签位置（柱状图顶部）
                            color: '#fff' // 标签颜色
                            // 自定义标签显示格式，带单位
                            // formatter: function (params) {
                            //     return params.value + ' %';
                            // }
                        },
                        barMaxWidth: 40,
                        data: seriesData5
                    }
                ]
            };
            this.complaintChart40704.setOption(option);
        },
        setChart5(resData) {
            let xAxisData = [],
                seriesData1 = [],
                seriesData2 = [],
                legendData = ['投诉全量', '诉求工单'];

            if (!resData) {
                return;
            }

            seriesData1 = [
                { value: resData['rider'] || 0, name: '骑手' },
                { value: resData['thirdParty'] || 0, name: '三者' },
                { value: resData['riderFamily'] || 0, name: '骑手家属' },
                { value: resData['thirdPartyFamily'] || 0, name: '三者家属' },
                { value: resData['riderAgent'] || 0, name: '骑手代理人' },
                { value: resData['thirdPartyAgent'] || 0, name: '三者代理人' },
                { value: resData['serviceProvider'] || 0, name: '服务商' },
                { value: resData['foodLiabilityInsuranceCustomer'] || 0, name: '食责险客户' },
                { value: resData['repairShop'] || 0, name: '修理厂' },
                { value: resData['other'] || 0, name: '其他' }
            ];

            let chartDom = document.getElementById('complaintChart50704');
            this.complaintChart5 = echarts.init(chartDom);

            let option = {
                textStyle: {
                    fontSize: 14
                },
                grid: {
                    left: '20%',
                    right: '10%',
                    top: '10%',
                    bottom: '10%'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        center: ['50%', '55%'],
                        data: seriesData1,
                        avoidLabelOverlap: true,
                        label: {
                            color: '#fff',
                            alignTo: 'radial',
                            // formatter: '{b}\n{c} ({d}%)',
                            formatter: '{b}\n{d}%',
                            lineHeight: 15
                        },
                        labelLine: {
                            show: true,
                            length: 30,
                            length2: 100,
                            lineStyle: {
                                // color: '#999',
                                width: 1
                            }
                        }
                    }
                ]
            };
            this.complaintChart5.setOption(option);
        }
    },
    watch: {
        chartsDictData: {
            handler(val) {},
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/table_public.css';
.complaintBox {
    background: #0c2452;
    // border-radius: 5px;
    padding: 0 10px;
    overflow: hidden;
    margin-bottom: -10px;
    min-width: 1390px;
    .page_title {
        text-align: center;
        padding-top: 20px;
        position: relative;
        margin-bottom: -20px;
        b {
            color: #fff;
            // color: #25e9ee;
            font-size: 26px;
            font-weight: bold;
            letter-spacing: 8px;
            position: relative;
            z-index: 3;
            top: -14px;
        }
        .titleImg {
            width: 700px;
            height: 50px;
            top: -56px;
        }
    }
}
.pdfBox {
    // width: 1000px;
    // height: 1000px;
    // position: absolute;

    /deep/ .el-table th {
        div {
            margin-top: -10px !important;
            height: 30px !important;
            line-height: 30px !important;
            padding-top: 0px !important;
            padding-bottom: 0px !important;
        }
    }
    /deep/ .el-table td {
        div {
            margin-top: -5px !important;
            height: 30px !important;
            line-height: 30px !important;
            padding-top: 0px !important;
            padding-bottom: 0px !important;
        }
    }
}

.pdf_page {
    background: #0c2452;
    color: #000;
    height: 2100px;
    /* border-bottom: 1px solid red; */
    /* border-top: 1px solid blue; */
    overflow: hidden;
    position: relative;
    padding-bottom: 20px;
    .editBox {
        p {
            background: #0c2452;
            color: #fff;
            font-size: 20px;
        }
    }
}
.page_footer {
    text-align: center;
    font-size: 18px;
    padding-bottom: 5px;
    position: absolute;
    left: 50%;
    bottom: 20px;
    color: #fff;
    transform: translateX(-50%);
}
.chartTitle {
    margin-bottom: 10px;
    // color: #409eff !important;
    color: #7dbdff !important;
    font-size: 20px;
    font-weight: bold;
}
.chartTitle::before {
    display: inline-block;
    content: '';
    width: 4px;
    height: 17px;
    background: #409eff;
    border-radius: 3px;
    margin-right: 0.12rem;
    position: relative;
    top: 2px;
}
.jiaoStyle {
    width: 100%;
    height: 342px;
    position: absolute;
    left: 0;
    top: 0;
    .jiao {
        width: 20px;
        height: 2px;
        background: #25e9ee;
        position: absolute;
        z-index: 5;
        box-shadow: 0 0 5px rgba(37, 233, 238, 0.5), 0 0 10px rgba(37, 233, 238, 0.4), 0 0 15px rgba(37, 233, 238, 0.3), 0 0 0 1px rgba(37, 233, 238, 0.2);
        animation: glow 2s infinite alternate ease-in-out;
    }
    .jiao::before {
        background: #25e9ee;
        box-shadow: 0 0 5px rgba(37, 233, 238, 0.5), 0 0 10px rgba(37, 233, 238, 0.4), 0 0 15px rgba(37, 233, 238, 0.3), 0 0 0 1px rgba(37, 233, 238, 0.2);
        animation: glow 2s infinite alternate ease-in-out;
    }
    .leftTop {
        top: 0;
    }
    .leftTop::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        left: -9px;
        top: 9px;
    }

    .rightTop {
        top: 0;
        right: 0;
    }
    .rightTop::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        right: -9px;
        top: 9px;
    }

    .leftBottom {
        bottom: 0px;
    }
    .leftBottom::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        left: -9px;
        bottom: 9px;
    }

    .rightBottom {
        bottom: 0px;
        right: 0;
    }
    .rightBottom::before {
        content: '';
        display: inline-block;
        width: 19px;
        height: 2px;
        position: absolute;
        transform: rotate(90deg);
        right: -9px;
        bottom: 9px;
    }
}
.search_box {
    padding-bottom: 0;
    // margin-bottom: 20px;
    .form_date {
        width: 290px;
        background: #0c2452ed;
        color: #fff;
        /deep/ input {
            background: #0c2452 !important;
        }
        /deep/ * {
            color: #fff;
        }
    }
}
.public_box {
    position: relative;
    border: 0;
    box-shadow: none;
    background: #0c2452;
}
.charts_null {
    text-align: center;
    font-size: 0.2rem;
    color: #666;
    line-height: 3.3rem;
}
.null_data {
    width: 100%;
    text-align: center;
    font-size: 0.16rem;
    color: #333;
    padding-top: 0.44rem;
}
.null_data div {
    width: 1.93rem;
    margin: 0 auto 0.24rem;
}
.charts_bar {
    width: 100%;
    height: 3.3rem;
    margin-top: 0.1rem;
}
.chartBox {
    width: 100%;
    height: 350px;
    margin-bottom: 20px;
    .complaintChartStyle {
        width: 100%;
        height: 300px;
    }
    .jiaoStyle {
        height: 348px;
    }
    .chartStyle4 {
        height: 400px;
    }
}
.tableBox {
    margin-bottom: 20px;
    min-height: 8.7rem;
    .jiaoStyle {
        height: 468px;
    }
    .chartTitle {
        margin-bottom: 10px;
    }
}

.tablesBox {
    // margin-bottom: 20px;
    .chartTitle {
        margin-bottom: 10px;
    }
    .left_tableBox {
        // width: 60%;
        min-height: 6.3rem;
        .jiaoStyle {
            height: 338px;
        }
        /deep/ .fontTableStyle {
            th.el-table__cell {
                > .cell {
                    font-size: 16px;
                }
            }
        }
    }
    .right_tableBox {
        // width: 50%;
        width: 100%;
        min-height: 6.3rem;
        .jiaoStyle {
            height: 340px;
        }
        .complaintChartStyle {
            width: 100%;
            min-height: 5.1rem;
        }
    }
}
.wrap {
    width: 100%;
    /* height: 100%; */
    position: relative;
    padding: 0 !important;
}
.editBox {
    margin-bottom: 20px;
    .left_edit {
        width: 59%;
    }
    .right_edit {
        width: 39%;
    }
}
</style>